
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { refreshData } from './refreshData'

export type PublishScenarioPayload = {
  id: EntityId // The Scenario Id
  dateOfOperation: string
  dateOfWeek: string
  unassignedOrderCount: number
  weekday: number
  name: string
  runIds: EntityId[]
  onSuccess?: () => void
}

export const publishScenario = createAsyncThunk<number | null, PublishScenarioPayload, ThunkApiContext>(
  'scenario/publishScenario',
  async ({ onSuccess, ...payload }, { dispatch }) => {
    await OLMSApiService.post<null>('planning/publishScenario', payload)
    await dispatch(refreshData({}))

    const orderInboxCount = await OLMSApiService.get<number>('/planning/OrderInboxCount')

    if (onSuccess) {
      onSuccess()
    }

    return orderInboxCount
  },
)
